import React from 'react';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import { RadioButtonGroup } from 'sabre-spark-react';
import { noop } from 'lodash';

const TRANSPORTATION_DETAILS = [
    {
        refValue: 4,
        code: 'arrivalTimeAlwaysRequired',
        title: 'Arrival Time always required'
    },
    {
        refValue: 5,
        code: 'arrivalTimeNotRequired',
        title: 'Arrival Time not required'
    },
    {
        refValue: 6,
        code: 'arrivalTimeRequiredIfEntered',
        title: 'Arrival Time required if entered'
    }
]

const TransportationSettings = ({
    currentConfigCopy = {},
    handleTransportationArrivalChange,
    isDisabled = false,
    registerSection,
    sectionStyleHandler,
    toggleConfigBoolean = noop
}) => {
    return (
        <section
            className="row spark-panel__content"
            ref={registerSection(2)}
            style={sectionStyleHandler(2)}
        >
            <div className="col-xs-12">
                <h4>Transportation Settings </h4>
                <ConfigurationCheckbox
                    title="Display Transportation options"
                    isDisabled={isDisabled}
                    ref={registerSection(7)}
                    style={sectionStyleHandler(7)}
                    code="enableTransportationDetails"
                    onChange={toggleConfigBoolean}
                    value={currentConfigCopy.enableTransportationDetails}
                />
                {currentConfigCopy.enableTransportationDetails && (
                    <RadioButtonGroup className="spark-panel__content">
                        <p>You can check only one option:</p>
                        {TRANSPORTATION_DETAILS.map((setting, index) => (
                            <ConfigurationCheckbox
                                key={`transportation-setting-${index}`}
                                title={setting.title}
                                ref={registerSection(setting.refValue)}
                                style={sectionStyleHandler(setting.refValue)}
                                isDisabled={isDisabled}
                                code={setting.code}
                                onChange={handleTransportationArrivalChange}
                                value={currentConfigCopy[setting.code]}
                            />
                        ))}
                    </RadioButtonGroup>
                )}
            </div>
        </section>
    )
};

export default TransportationSettings;


// WEBPACK FOOTER //
// ./src/components/pages/pages/guestPayment/transportation-settings.js